import { render, staticRenderFns } from "./refusePop.vue?vue&type=template&id=ed10d1a2&"
import script from "./refusePop.vue?vue&type=script&lang=js&"
export * from "./refusePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports